import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import GridItemTitle from "./GridItemTitle";
import RatingWidget from "./RatingWidget";
import GridItemDesc from "./GridItemDesc";
import GridItemCompare from "./GridItemCompare";
import LocalUrlMaker from "../../../lib/LocalUrlMaker";
import Money from "../../../lib/Money";

export default function ToolGridItemInfoBlock({
  item, handleClick, gridState, gridId, path,
  hidePricing = false,
  ...props
}) {

  path ||= LocalUrlMaker.prefixedPath(item.path);

  return <div className="p-2">
    <GridItemTitle item={item} path={path}
      handleClick={handleClick}/>

    <RatingWidget item={item}/>

    {!hidePricing && <ToolPricingWidget item={item}/>}

    {gridState.showCompare && !item.vendorsku && false && <GridItemCompare
      gridId={gridId}
      item={item}
      gridState={gridState}
    />}
  </div>
}

function ToolPricingWidget({
  item
}) {
  let lowPrice = +(item.price || 0);
  let highPrice = +(item.priceHigh || item.price);

  let lowUSD = new Money(lowPrice);

  if (lowPrice === highPrice) {
    return <div className="text-lg my-2">
      <span className="font-bold">${lowUSD.toString('')}</span>
    </div>
  }

  let highUSD = new Money(highPrice);

  return <div className="text-lg my-2">
    <span className="font-bold">${lowUSD.toString('')}</span>
    {' '} &mdash; {' '}
    <span className="font-bold">{highUSD.toString('')}</span>
  </div>
}
